import { memo } from 'react';

const ClosePopoverIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="11"
		height="10"
		fill="none"
		viewBox="0 0 11 10"
	>
		<path
			stroke="#69729D"
			strokeLinecap="square"
			d="M.844.734 9.398 9.29M9.398.734.844 9.29"
		></path>
	</svg>
);

export default memo(ClosePopoverIcon);
